import { createFileRoute } from "@tanstack/react-router";
import { getSocialEmotionalEditPage } from "#/modules/sociaal-emotioneel/social-emotional.functions";
import { SociaalEmotioneelThemasReeksCrudPage } from "#/modules/sociaal-emotioneel/components/page.crud-sociaal-emotioneel";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/admin/social-emotional/$id/edit/",
)({
  loader: ({ params }) => getSocialEmotionalEditPage({ data: { id: params.id } }),
  component: AdminSocialEmotionalEditPage,
});

function AdminSocialEmotionalEditPage() {
  const loaderData = Route.useLoaderData();
  return (
    <SociaalEmotioneelThemasReeksCrudPage
      sociaalEmotioneelThemasReeks={loaderData.sociaalEmotioneelThemasReeks}
      isEditRoute={loaderData.isEditRoute}
      basePath="../social-emotional"
    />
  );
}
